<template>
  <div class="header">
    <div class="header__options">
      <div class="header__espacio">
        <img src="@/assets/img/espacio_movistar_logo.png" />
      </div>
      <div class="header__options--menu-right">
        <img
          class="header__logo"
          src="@/assets/img/logo.svg"
          @click="goToPage('Home')"
        />
      </div>
      <div class="header__sede">
        <span class="header__sede--ciudad">{{ $t('header.sede.ciudad') }}</span>
        <span class="header__sede--direccion">{{
          $t('header.sede.direccion')
        }}</span>
      </div>
    </div>
    <div class="header__abajo">
      <div class="header__menu" v-if="experienceTypes.length < 1">
        <animated-placeholder height="14px" width="140px" />
        <animated-placeholder height="14px" width="55px" />
        <animated-placeholder height="14px" width="55px" />
        <animated-placeholder height="14px" width="140px" />
      </div>
      <div class="header__menu" v-else>
        <span
          :class="[
            $route.name == 'Home'
              ? 'header__menu--item-selected'
              : 'header__menu--item'
          ]"
          @click="goToPageAndScroll('#maps')"
          >{{ $t('header.menu.discover') }}</span
        >
        <span
          :class="[
            $route.name == 'ExperienceTypes' && $route.href != ''
              ? 'header__menu--item-selected'
              : 'header__menu--item'
          ]"
          @click="goToPage('ExperienceTypes')"
          >{{ $t('header.menu.agenda') }}</span
        >
        <span
          :class="[
            experienceTypeCode == 'STU'
              ? 'header__menu--item-selected'
              : 'header__menu--item'
          ]"
          v-for="(experienceType, index) in experienceTypesFilter"
          :key="index"
          @click="goTo(experienceType)"
        >
          {{ translate(experienceType.title) }}
        </span>
        <span class="header__menu--item" @click="openAppointmentManagement">{{
          $t('header.menu.commercial-attention')
        }}</span>
      </div>
      <LanguageChange
        flexJustify="flex-end"
        :showLogo="false"
        color="#fff"
        padding="0px"
      />
    </div>
  </div>
  <QrTotem
    :abierto="qrAbierto"
    :qr="qrAtencion"
    @cerrar="qrAbierto = false"
  />
  <CabeceraMovil
    :tipos="experienceTypesFilter"
    @descubre="goToPageAndScroll('#maps')"
    @agenda="goToPage('ExperienceTypes')"
    @tipo="goTo"
    @atencion="openAppointmentManagement"
  />
</template>

<script setup>
  import { computed, onMounted, ref, watch } from 'vue'
  import router from '@/router'
  import { useStore } from 'vuex'
  import LanguageChange from '@/components/movistar/common/LanguageChange.vue'
  import CabeceraMovil from '@/layouts/vertical/CabeceraMovil.vue'
  import commonMethods from '@/commonMethods'
  import AnimatedPlaceholder from '@/libs/AnimatedPlaceholder.vue'
  import QrTotem from '@/components/movistar/common/QrTotem.vue'
  import i18n from '@/plugins/i18n'
  import { enlaceDeLaWeb, imagenDelQr } from '@/plugins/qrTotem'
  const { scrollToAnchor } = commonMethods()

  const store = useStore()
  const { registerError, translate } = commonMethods()

  const experienceTypes = computed(() => store.getters['getExperienceTypes'])
  const experienceTypesFilter = computed(() =>
    experienceTypes.value.filter(
      (experienceType) => experienceType.code === 'STU'
    )
  )

  const experienceTypeCode = ref(
    router.currentRoute.value.params.experienceTypeCode || ''
  )

  const goToPage = (url) => {
    router.push({ name: url })
  }
  const goToPageAndScroll = (anchor) => {
    if (router.currentRoute.value.name === 'Home') {
      scrollToAnchor(anchor)
    } else {
      router.push({ name: 'Home', query: { scrollTo: anchor } })
    }
  }

  const goTo = async (experienceType) => {
    store.commit('setExperienceType', experienceType)

    if (experienceType.code === 'CINE') {
      router.push({ name: 'Cinema' })
    } else {
      let experiences = await store.dispatch(
        'getExperiencesByType',
        experienceType.experienceTypeId
      )
      if (experiences?.length > 1) {
        router.push({
          name: 'ExperiencesByType',
          params: {
            experienceTypeCode: experienceType.code
          }
        })
      } else {
        if (experiences?.length == 1) {
          const experience = await store.dispatch(
            'getExperience',
            experiences[0].experienceId
          )

          if (experience) {
            router.push({
              name: 'Experience'
            })
          } else {
            registerError(
              'ExperienceTypesView',
              `Error al recuperar la experiencia con identificador ${experiences[0].experienceId}`
            )
          }
        } else {
          registerError(
            'ExperienceTypesView',
            `Error: no existen experiencias para el tipo ${experienceType.experienceTypeId}`
          )
        }
      }
    }
  }

  const qrAbierto = ref(false)
  const qrAtencion = ref('')
  const openAppointmentManagement = () => {
    if (sessionStorage.getItem('modoTotem') === '1') {
      qrAtencion.value = imagenDelQr(enlaceDeLaWeb({ procedure: 'visible', lang: i18n.global.locale.value }, '/commercial/'))
      qrAbierto.value = true
      return
    }
    window
      .open(
        'https://appweb.movistar.es/pages/appointment-booking?venue-id=000009QQ&venue-name=Espai%20Movistar&latitude=41.3870796&longitude=2.1718682&venue-phone=933010400',
        '_blank'
      )
      .focus()
  }

  watch(
    () => router.currentRoute.value.params.experienceTypeCode,
    (newValue) => {
      experienceTypeCode.value = newValue || ''
    }
  )
</script>

<style lang="scss">
  @import '@/scss/mixings';

  .header {
    @include d-flex(column, space-between, center, 30px);
    width: 100%;
    padding: 20px 50px;

    background: rgb(0, 102, 255);
    //background: rgb(1, 157, 244);
    //background: linear-gradient(
    //  45deg,
    //  rgba(1, 157, 244, 1) -5%,
    //  rgba(11, 39, 57, 1) 50%
    //);

    @media screen and (max-width: $sm-breakpoint) {
      display: none;
    }
    &__espacio {
      height: 36px;

      & img {
        height: inherit;
      }
    }
    &__logo {
      width: 65px;
      height: auto;
      cursor: pointer;
    }
    &__sede {
      @include d-flex(column, center, flex-end, 1px);
      color: #fff;
      line-height: 1.25;
      text-align: right;
      white-space: nowrap;
      &--ciudad {
        font-family: 'OnAir-text-bold';
        font-size: 15px;
      }
      &--direccion {
        font-size: 13px;
      }
    }
    &__abajo {
      @include d-flex(row, space-between, center, 4dvw);
      width: 100%;
      & .language {
        width: auto;
        flex: none;
        gap: 8px;
        font-size: 14px;
      }
    }
    &__options {
      @include d-flex(row, space-between, center, 30px);
      width: 100%;
      &--menu-right {
        @include d-flex(column, space-between, initial, 15px);
      }
    }
    &__menu {
      @include d-flex(row, flex-start, center, 4dvw);
      flex-wrap: wrap;
      width: 100%;
      color: #fff;
      &--item {
        cursor: pointer;
        font-family: 'OnAir-text-bold';

        &:hover {
          font-family: 'OnAir-text-black';
          color: var(--primary-40-color);
        }
      }
      &--item-selected {
        cursor: pointer;
        font-family: 'OnAir-text-black';
        //color: var(--primary-40-color);
        color: rgb(2, 45, 103);
      }
    }
  }

  .header-mobile {
    @include d-flex(row, space-between, center);
    width: 100%;
    padding: 10px;
    height: 60px;
    &__left {
      width: 20%;
    }
    &__menu {
      @include d-flex(column, space-between, center, 8px);
      &--images {
        @include d-flex(column, center, center);
        gap: 11.46px;
        font-size: 10px;
        line-height: 20px;
      }
      &--logo {
        padding-top: 7.7px;
        max-width: 11.75rem;
        max-height: 2rem;
      }
      &--container {
        @include d-flex(row, center, center, 5px);
      }
    }
    &__right {
      width: 20%;
    }
    @media screen and (min-width: $sm-breakpoint) {
      display: none;
    }
  }
</style>
